export const FAYTEX_FAQ_SECTIONS = [
  {
    id: "about",
    title: "About Faytex",
    items: [
      {
        q: "What is Faytex?",
        a: "Faytex is the flagship sanitary pad brand of Fay International Ltd, a Ghanaian manufacturer committed to providing women and girls with comfortable, reliable, and affordable menstrual hygiene products.",
      },
      {
        q: "Is Faytex only for maternity use?",
        a: "No. While Fay International has a long history of supporting women's hygiene needs, Faytex sanitary pads are designed for girls and women at every stage of their menstrual journey — from first periods and regular monthly cycles to heavier flow days and maternity-related needs.",
      },
      {
        q: "Who can use Faytex sanitary pads?",
        a: "Faytex sanitary pads are suitable for teenagers, young women, adults, and women experiencing different levels of menstrual flow.",
      },
    ],
  },
  {
    id: "range",
    title: "Faytex Product Range",
    items: [
      {
        q: "What types of sanitary pads does Faytex offer?",
        a: "Faytex currently offers:\n• Normal Flow Pads\n• Heavy Flow / Super Pads\n• Extra Long / Night Towels\n• Multipack (16 pieces)",
      },
      {
        q: "What is included in the Faytex Multipack?",
        a: "The Faytex Multipack contains:\n• 4 Normal Flow Pads\n• 6 Heavy Flow Pads\n• 6 Extra Long / Night Towels\n\nThis lets women choose the right protection throughout different stages of their menstrual cycle.",
      },
      {
        q: "Which Faytex pad is best for heavy flow days?",
        a: "The Heavy Flow and Extra Long / Night Towels provide additional absorbency and protection for heavier flow days.",
      },
      {
        q: "Which Faytex pad is best for overnight protection?",
        a: "The Extra Long / Night Towels are designed to provide extended coverage and protection while sleeping.",
      },
    ],
  },
  {
    id: "safety",
    title: "Comfort & Safety",
    items: [
      {
        q: "Do Faytex sanitary pads have wings?",
        a: "Yes. Faytex sanitary pads feature secure wings designed to help keep the pad in place and provide additional protection. Some consumers may not be aware that Faytex sanitary pads now include wings as part of our commitment to continually improving comfort, protection, and confidence for women and girls.",
      },
      {
        q: "What are Faytex sanitary pads made from?",
        a: "Faytex sanitary pads are made from pure wood pulp and carefully selected materials designed to provide comfort, absorbency, and protection.",
      },
      {
        q: "Are Faytex sanitary pads suitable for teenagers?",
        a: "Yes. Faytex sanitary pads are suitable for girls from their first period onwards.",
      },
    ],
  },
  {
    id: "use",
    title: "How to Use Faytex",
    items: [
      {
        q: "How often should I change my sanitary pad?",
        a: "It is generally recommended to change your sanitary pad every 4–6 hours, or more frequently depending on your flow.",
      },
      {
        q: "Can I wear the same pad all day?",
        a: "No. Changing your pad regularly helps maintain hygiene, comfort, and protection.",
      },
    ],
  },
  {
    id: "period",
    title: "Understanding Your Period",
    items: [
      {
        q: "Is it normal for my flow to change during my period?",
        a: "Yes. Many women experience lighter and heavier days throughout their menstrual cycle.",
      },
      {
        q: "Can I exercise while on my period?",
        a: "Yes. Many women continue their normal activities, including exercise, while menstruating.",
      },
      {
        q: "Are painful periods normal?",
        a: "Mild discomfort is common. However, severe or persistent pain should be discussed with a healthcare professional.",
      },
    ],
  },
  {
    id: "buying",
    title: "Buying Faytex",
    items: [
      {
        q: "Where can I buy Faytex sanitary pads?",
        a: "Faytex products are available through retailers, supermarkets, pharmacies, distributors, and selected outlets across Ghana.",
      },
      {
        q: "Is Faytex available outside Ghana?",
        a: "Faytex is currently focused on serving Ghanaian consumers while exploring expansion opportunities into neighbouring African markets.",
      },
    ],
  },
];

export const FAYTEX_MYTHS = [
  { myth: "Faytex is only for maternity use.", fact: "Faytex serves girls and women across different stages of their menstrual journey." },
  { myth: "Faytex pads do not have wings.", fact: "Faytex sanitary pads feature secure wings for added protection and comfort." },
  { myth: "Teenagers cannot use Faytex.", fact: "Faytex is suitable from a girl's first period onwards." },
  { myth: "A sanitary pad can be worn all day.", fact: "Pads should be changed regularly to maintain hygiene and comfort." },
];
